import wethLogo from 'src/assets/icons/common/weth.svg';
import { AbgToken, JamboToken, NoearToken, ShitZuToken } from '../assets/icons';

export const tokenLogos: Record<string, string> = {
  ETH: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/info/logo.png',
  WETH: wethLogo,
  BTC: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/bitcoin/info/logo.png',
  USDC: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48/logo.png',
  USDT: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png',
  WBTC: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599/logo.png',
  SEI: 'https://img.cryptorank.io/coins/sei_network1661962346631.png',
  AURORA:
    'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/aurora/info/logo.png',
  cbBTC: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32994.png',
  ARB: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/arbitrum/info/logo.png',
  OP: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/optimism/info/logo.png',
  POL: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/polygon/info/logo.png',
  BNB: 'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png',
  KNC: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9444.png',
  TURBO: 'https://s2.coinmarketcap.com/static/img/coins/64x64/24911.png',
  DAI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png',
  ASTER: 'https://s2.coinmarketcap.com/static/img/coins/64x64/36341.png',
  KAITO: 'https://s2.coinmarketcap.com/static/img/coins/64x64/35763.png',
  AVAX: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5805.png',
  HAPI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/8567.png',
  SWEAT: 'https://s2.coinmarketcap.com/static/img/coins/64x64/21351.png',
  RHEA: 'https://s2.coinmarketcap.com/static/img/coins/64x64/37529.png',
  NEAR: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6535.png',
  GMX: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11857.png',
  MOG: 'https://s2.coinmarketcap.com/static/img/coins/64x64/27659.png',
  AAVE: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7278.png',
  UNI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/7083.png',
  LINK: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1975.png',
  SHIB: 'https://s2.coinmarketcap.com/static/img/coins/64x64/5994.png',
  PEPE: 'https://s2.coinmarketcap.com/static/img/coins/64x64/24478.png',
  BRETT: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29743.png',
  USD1: 'https://s2.coinmarketcap.com/static/img/coins/64x64/36148.png',
  USDf: 'https://s2.coinmarketcap.com/static/img/coins/64x64/35721.png',
  wNEAR: 'https://s2.coinmarketcap.com/static/img/coins/64x64/11808.png',
  FRAX: 'https://s2.coinmarketcap.com/static/img/coins/64x64/6953.png',
  wBTC: 'https://s2.coinmarketcap.com/static/img/coins/64x64/3717.png',
  BLACKDRAGON: 'https://s2.coinmarketcap.com/static/img/coins/64x64/29627.png',
  SHITZU: ShitZuToken,
  ABG: AbgToken,
  NOEAR: NoearToken,
  mpDAO: 'https://s2.coinmarketcap.com/static/img/coins/64x64/38103.png',
  JAMBO: JamboToken,
  NearKat: 'https://s2.coinmarketcap.com/static/img/coins/64x64/34150.png',
  PUBLIC: 'https://s2.coinmarketcap.com/static/img/coins/64x64/37728.png',
  ZEC: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1437.png',
  EVAA: 'https://s2.coinmarketcap.com/static/img/coins/64x64/38376.png',
  CFI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/39057.png'
};
